import { ApolloClient, ApolloClientOptions, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { HttpLink } from '@apollo/client/link/http';
import { StatusCodes } from 'http-status-codes';
import { SE_API_TOKEN_KEY, SE_API_TOKEN_VALUE } from '../common/types/constants';
export interface IProtectedResourceClientConfig extends ApolloClientOptions<any> {
  refreshJwtUri?: string;
  uri: string;
}

interface IJWTClaim {
  sub: string;
  exp: number;
}

const SECOND_IN_MS: number = 1000;

export const clearV4JwtToken: () => void = () => {
  sessionStorage.removeItem('v4-jwt-token');
};

export const getAuthorisationLink: (refreshJwtUri: string) => ApolloLink = refreshJwtUri =>
  setContext(async (_, { headers: requestHeaders }) => {
    let sparrowSeAccessToken: string = sessionStorage.getItem('v4-jwt-token');
    let isTokenValid: boolean = false;
    if (sparrowSeAccessToken) {
      const jwtClaims: IJWTClaim = JSON.parse(atob(sparrowSeAccessToken.split('.')[1]));
      isTokenValid = jwtClaims.exp - Date.now() / SECOND_IN_MS > 0;
    }

    if (!isTokenValid) {
      const response: Response = await window.fetch(refreshJwtUri, {
        credentials: 'include',
        headers: {
          Accept: 'text/plain',
          'Content-Type': 'text/plain',
          [SE_API_TOKEN_KEY]: SE_API_TOKEN_VALUE,
        },
      });

      sparrowSeAccessToken = await response.text();

      if (response.status === StatusCodes.OK) {
        sessionStorage.setItem('v4-jwt-token', sparrowSeAccessToken);
      } else {
        return null;
      }
    }

    return {
      headers: {
        ...requestHeaders,
        'v4-jwt-token': `${sparrowSeAccessToken}`,
      },
    };
  });

/** Custom ResourceClient with authentication */
export default class ProtectedResourceClient<TCache> extends ApolloClient<TCache> {
  constructor(options: IProtectedResourceClientConfig) {
    options.link = options.link
      ? ApolloLink.from([
          getAuthorisationLink(options.refreshJwtUri),
          new HttpLink({
            uri: options.uri,
          }),
          options.link,
        ])
      : ApolloLink.from([
          getAuthorisationLink(options.refreshJwtUri),
          new HttpLink({
            uri: options.uri,
          }),
        ]);

    super(options);
  }
}
